import React from "react";
import "../../styles/components/floating-card.css";

const FloatingCard = ({
  children,
  className = "",
  onClick,
  hover = true,
  transparent = true,
  animationDelay = "0s",
  size = "medium", // small, medium, large, full
  style = {},
}) => {
  const cardClasses = [
    "floating-card",
    `floating-card-${size}`,
    transparent ? "floating-card-transparent" : "floating-card-solid",
    hover ? "floating-card-hover" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const cardStyle = {
    animationDelay,
    ...style,
  };

  return (
    <div className={cardClasses} onClick={onClick} style={cardStyle}>
      <div className="floating-card-content">{children}</div>
    </div>
  );
};

export default FloatingCard;
